<template>
  <v-row>
    <v-col>
      <v-row dense>
        <v-col class="text-h5 gray--text">
          Anestesia
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="6">
          <v-combobox
            label="Anestesista"
            v-model="anesthetist"
            dense
            hide-details
            outlined
            :items="doctorUsers"
            item-text="employee.name"
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            label="Auxiliares"
            v-model="assistants"
            dense
            hide-details
            outlined
            :items="nurseUsers"
            item-text="employee.name"
            multiple
            chips
            deletable-chips
            small-chips
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Anestesista"
            v-model="descriptionModel"
            dense
            hide-details
            outlined
            :items="descriptionModels"
            item-text="name"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            label="Modelo de anestesista"
            v-model="descriptionTemplate"
            dense
            hide-details
            outlined
            :items="descriptionModelTemplates"
            item-text="name"
            background-color="white"
            @change="choseDescriptionTemplate"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <RichText v-model="description" @change="debouncedSave" :disabled="disabled" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Anexos Anestesia
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Intraoperative::Anesthesia"
            :ownerId="anesthesia.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "SurgeryIntraoperativeAnesthesia",
    props: {
      attendance: Object,
      surgery: Object,
      refreshSurgery: Function,
      doctorUsers: Array,
      nurseUsers: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        anesthetist: null,
        assistants: [],
        description: "",
        descriptionModel: null,
        descriptionTemplate: null,
      };
    },
    watch: {
      doctorUser() {
        this.loadUsers();
      },
      nurseUsers() {
        this.loadUsers();
      },
    },
    created() {
      this.debouncedSave = this.lodash.debounce(this.saveSurgeryPreoperativeAnesthesia, 2000);
    },
    mounted() {
      this.description = this.anesthesia.description;

      this.loadUsers();
    },
    apollo: {
      surgeryIntraoperativeAnesthesiaTypeTemplates: {
        query: require("@/graphql/surgery/surgery_intraoperative_anesthesia_type_templates.gql"),
      },
    },
    computed: {
      anesthesia() {
        return this.surgery.intraoperative.anesthesia;
      },
      descriptionModels() {
        return this.lodash.uniqBy(
          this.lodash.map(this.surgeryIntraoperativeAnesthesiaTypeTemplates, "anesthesiaType"),
          "id"
        );
      },
      descriptionModelTemplates() {
        if (this.descriptionModel?.id) {
          return this.lodash.filter(
            this.surgeryIntraoperativeAnesthesiaTypeTemplates,
            function(e) {
              return e.anesthesiaType.id === this.descriptionModel.id;
            }.bind(this)
          );
        }

        return [];
      },
    },
    methods: {
      loadUsers() {
        if (this.anesthesia.anesthetist?.id) {
          this.anesthetist = this.lodash.find(this.doctorUsers, {
            id: this.anesthesia.anesthetist.id,
          });
        }

        this.assistants = this.lodash.filter(
          this.nurseUsers,
          function(e) {
            return this.lodash.map(this.anesthesia.assistants, "id").includes(e.id);
          }.bind(this)
        );
      },
      saveSurgeryPreoperativeAnesthesia() {
        if (this.disabled) return;
        this.descriptionModel = null;
        this.descriptionTemplate = null;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/save_surgery_intraoperative_anesthesia.gql"),
          variables: {
            surgeryId: this.surgery.id,
            anesthetistId: this.lodash.get(this.anesthetist, "id", ""),
            description: this.description,
            assistantIds: this.lodash.map(this.assistants, "id"),
          },
        }).then(() => {
          this.refreshSurgery();
        });
      },
      choseDescriptionTemplate() {
        if (this.descriptionTemplate?.description) {
          if (!this.description) {
            this.description = this.descriptionTemplate.description;
          } else {
            this.description += "\n";
            this.description += this.descriptionTemplate.description;
          }

          this.debouncedSave();
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
